import React from "react";
import "./index.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";
import TelegramPage from "./pages/Telegram";
import RegistrationGuidePage from "./pages/RegistrationGuide";

function App() {
  return (
    <div className="min-h-screen bg-[#08030f] text-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/telegram" element={<TelegramPage />} />
          <Route path="/panduan-registrasi" element={<RegistrationGuidePage />} />
        </Routes>
        <Footer />
      </div>
  );
}

export default App;
